// constants
import { getTranslation } from './common';
//////////////////////////////////////////////////

const getRequiredLocaleTxt = () => getTranslation('errors.required', 'Field is required');

const getShouldBeFileLocaleTxt = () => getTranslation('errors.shouldBeAFile', 'Should be a .txt|.csv|.xlsx|.xls|.ods file');

const getShouldBeFromToCharLocaleTxt = (from = 0, to = 20) => `${
  getTranslation('errors.fieldLengthShouldBeFrom', 'Field length should be from')} ${from} ${getTranslation('labels.to', 'to')} ${to} ${
  getTranslation('labels.characters', 'characters')}`;

export {
  getRequiredLocaleTxt,
  getShouldBeFileLocaleTxt,
  getShouldBeFromToCharLocaleTxt,
};
